import { CSSObject } from '@chakra-ui/react';

export const DeductionsText: CSSObject = {
  color: 'gray.400',
  mb: '1',
  fontWeight: '600',
};

export const FooterMoreOpenText: CSSObject = {
  color: 'alpha.500',
  fontSize: 'xs',
  'div > svg': {
    color: 'beta.500',
  },
};

export const BoxMoreText: CSSObject = {
  w: '8',
  color: 'beta.500',
};

export const FooterBodyText: CSSObject = {
  color: 'gray.300',
};

export const toteMultiGrid: CSSObject = {
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '6',
  display: 'grid',
};

export const toteMultiGridText: CSSObject = {
  fontSize: 'xs',
  w: 'full',
  color: 'gray.400',
  mb: '2',
  '&.raceNumber': {
    fontWeight: 'semibold',
    borderBottom: '1px dashed',
    borderColor: '#00000040',
    boxShadow: '0px 1px 0px 0px #FFFFFF1A',
  },
};